document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('bulk-order-form');
  const submitBtn = form.querySelector('.bulk-form__submit');
  const submitText = form.querySelector('.bulk-form__submit-text');
  const submitLoading = form.querySelector('.bulk-form__submit-loading');

  form.addEventListener('submit', function() {
    submitText.style.display = 'none';
    submitLoading.style.display = 'flex';
    submitBtn.disabled = true;
  });
});
